import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ADMIN_FORGOT_PASSWORD,
  LOGIN_ADMIN,
  RESET_PASSWORD,
} from "../constants/apiConstants";
import { postApi } from "../../services/apiServices";
import Alertify from "../../services/alertify";

/*----------------Login Admin ---------------- */
export const LoginAdminData = createAsyncThunk(
  "login-admin/admin",
  async (reqData) => {
    try {
      const response = await postApi(LOGIN_ADMIN, reqData);
      return response;
    } catch (error) {
      console.log("Error Log In API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);

/*----------------Forgot Password ---------------- */
export const AdminForgotPwd = createAsyncThunk(
  "forgot-password-admin/admin",
  async (reqData) => {
    try {
      const response = await postApi(ADMIN_FORGOT_PASSWORD, reqData);
      return response;
    } catch (error) {
      console.log("Error Forgot API", error);
      const errorMessage = error.error?.email?.[0] || "An error occurred";
      Alertify.error("Forgot Password: " + errorMessage);
      return Promise.reject(error);
    }
  }
);

/*----------------Reset Password ---------------- */
export const AdminResetPwd = createAsyncThunk(
  "reset-password-admin/admin",
  async (reqData) => {
    try {
      const response = await postApi(RESET_PASSWORD, reqData);
      return response;
    } catch (error) {
      console.log("Reset Password API:", error);
      const errorMessage = error.error?.password?.[0] || "An error occurred";
      Alertify.error(errorMessage);
      return Promise.reject(error);
    }
  }
);
